// src/utils/urlUtils.js

export function getModifiedUrl(url) {
    try {
      let parsedUrl = new URL(url);
      let pathSegments = parsedUrl.pathname.split('/');
  
      // Define patterns where the last segment is considered an endpoint
      const endpointRoutes = ['/qr-customer-1', '/qr-customer-2'];
      const routePattern = endpointRoutes.find(route => parsedUrl.pathname.startsWith(route));
  
      if (routePattern) {
        // Remove the last segment (endpoint)
        if (pathSegments.length > 2) {
          const lastSegment = pathSegments.pop(); // Remove the last segment
  
          // Save the removed segment to local storage
          localStorage.setItem('removedPathSegment', lastSegment);
  
          // Update the pathname to exclude the last segment
          parsedUrl.pathname = pathSegments.join('/');
        }
      }
  
      return parsedUrl.href;
    } catch (err) {
      console.error('Invalid URL:', err);
      return url;
    }
  }
  